module.exports = __webpack_public_path__ + "static/wolfram-bb42a024df5cd8cc94e4b293e542a1c9.png";